import { render } from "./SingleBlogDark.vue?vue&type=template&id=2a6e00f6"
import script from "./SingleBlogDark.vue?vue&type=script&lang=js"
export * from "./SingleBlogDark.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__